/*
 * Async Treeview 0.1 - Lazy-loading extension for Treeview
 * 
 * http://bassistance.de/jquery-plugins/jquery-plugin-treeview/
 *
 * Copyright (c) 2007 Jörn Zaefferer
 *
 * Dual licensed under the MIT and GPL licenses:
 *   http://www.opensource.org/licenses/mit-license.php
 *   http://www.gnu.org/licenses/gpl.html
 *
 * Revision: $Id$
 *
 */

; (function ($) {

  function load(settings, jRoot, child, container) {

    function createNode(parent) {
      var current = $("<li/>").attr("id", this.id || "").html("<span>" + this.text + "</span>")

      if (this.path) current.data('path', this.path);
      if (this.classAttribute) current.attr('class', this.classAttribute);
      if (this.kind) current.attr('kind', this.kind);
      if (this.code) current.attr('id', this.code); //для отчетов

      if (this.data) {
        current.data('ex', $.parseJSON(this.data));
      }

      current.appendTo(parent);

      if (this.classes) {
        current.children("span").addClass(this.classes);
      }

      if (this.expanded) {
        current.addClass("open");
      }

      if (this.hasChildren || this.children && this.children.length) {
        var branch = $("<ul/>").appendTo(current);
        if (this.hasChildren) {
          current.addClass("hasChildren");
          createNode.call({
            classes: "placeholder",
            text: "&nbsp;",
            children: []
          }, branch);
        }
        if (this.children && this.children.length) {
          $.each(this.children, createNode, [branch])
        }
      }
    }

    var data;
    if (_.isObject(jRoot)) {
      var dataPath = jRoot.data('path');

      if (dataPath && dataPath.length) {
        data = {
          Path: dataPath,
          SelectedTreeItem: ""
        }
        data = $.toJSON(data);
      } else {
        var root = settings.ajax.rootFolderID ? settings.ajax.rootFolderID : jRoot.attr('id');
        data = "{'FolderID': '" + (root == 'source' ? '' : root) + "', " + settings.ajax.dataWS + "}";
      }
    } else {
      var rootFolderID = settings.ajax.rootFolderID ? settings.ajax.rootFolderID : jRoot;
      data = "{'FolderID': '" + (rootFolderID == 'source' ? '' : rootFolderID) + "', " + settings.ajax.dataWS + "}";
    }

    $.ajax($.extend(true, {
      url: settings.url,
      dataType: "json",
      data: data,
      success: function (response) {
        if (response.d.Success) {
          child.empty();
          $.each(response.d.Result, createNode, [child]);

          $(container).treeview({ add: child });
          if (settings.ajax.onAfterSuccess) settings.ajax.onAfterSuccess(child, $(container));
        }
      }
    }, settings.ajax));
  }

  var proxied = $.fn.treeview;
  $.fn.treeview = function (settings) {
    if (!settings.url) {
      return proxied.apply(this, arguments);
    }
    var container = this;
    if (!container.children().size())
      load(settings, "source", $(this), container);
    var userToggle = settings.toggle;
    return proxied.call(this, $.extend({}, settings, {
      collapsed: true,
      toggle: function () {
        var $this = $(this);

        if ($this.hasClass("hasChildren")) {
          var childList = $this.removeClass("hasChildren").find("ul");
          load(settings, $(this), childList, container);
        }
        if (userToggle) {
          userToggle.apply(this, arguments);
        }
      }
    }));
  };

})(jQuery);